// -- == //
import { Pagination, notification } from 'antd';
import { FC, useState, useEffect } from 'react';
import { ReactSVG } from 'react-svg';
import * as S from './styles';
import AppLoading from 'components/appLoading';

interface IProps {
  altanfeethiFields: any;
  headers: IPropsHeader[];
  data: any[];
  style?: object;
  totlaItems?: number;
  pagination?: boolean;
  headerStyle?: 'two' | 'one';
  headerColor?: string;
  loading?: boolean;
  lastItemRef?: (node: HTMLElement | null) => void;
}

interface IPropsHeader {
  id: string | number;
  title: string;
  icon?: string;
  dir?: 'left' | 'right';
  width?: string | number;
  padding?: string;
}

const AppTable: FC<IProps> = ({
  altanfeethiFields,
  data,
  headers,
  style,
  pagination,
  totlaItems,
  headerStyle = 'one',
  headerColor = '#8A93AC',
  loading,
  lastItemRef
}) => {
  const [page, setPage] = useState<number>(1);

  const handleChnage = (newPage: number) => {
    setPage(newPage);
  };

  //

  useEffect(() => {
    // if (!Array.isArray(data)) {
    //   notification.error({
    //     message: 'Data Fetch Error',
    //     description: 'There was a problem fetching the data.',
    //     placement: 'topRight'
    //   });
    // }
  }, [data]);

  return (
    <>
      <S.TableCon>
        {loading ? (
          <S.TableLoading>
            <img src="/logos/logo-mini.png" width={70} height={70} />
            <S.Loader>
              <ReactSVG
                src="/loader.svg"
                wrapper="span"
                beforeInjection={(svg) => {
                  svg.setAttribute('width', `70px`);
                  svg.setAttribute('height', `70px`);
                }}
              />
            </S.Loader>
          </S.TableLoading>
        ) : (
          <></>
        )}
        <S.Table style={style}>
          <S.Thead className={headerStyle}>
            <S.Tr>
              {headers?.map((item: IPropsHeader, index) => (
                <S.Th key={index} style={{ width: item.width, padding: item.padding }}>
                  <S.HeaderTh
                    key={item.id}
                    style={{
                      color: headerColor,
                      justifyContent: item.dir || 'center'
                    }}
                  >
                    {item.icon ? (
                      <ReactSVG
                        src={item.icon}
                        beforeInjection={(svg) => {
                          svg.setAttribute('stroke', `${headerColor}`);
                        }}
                      />
                    ) : (
                      <></>
                    )}
                    {item.title}
                  </S.HeaderTh>
                </S.Th>
              ))}
            </S.Tr>
          </S.Thead>
          <S.Tbody>
            {/* {data?.map((item: any, index) => (
              <S.Tr key={index}>
                {Object.values(altanfeethiFields)?.map((field: any, index2) => (
                  <S.Td key={`td-${index2}`}>{field(item)}</S.Td>
                ))}
              </S.Tr>
            ))} */}
            {Array.isArray(data) &&
              data.length > 0 &&
              data.map((item: any, index) => {
                const isLast = index === data.length - 1;
                return (
                  <S.Tr key={index} ref={isLast ? lastItemRef || null : null}>
                    {Object.values(altanfeethiFields)?.map((field: any, index2) => (
                      <S.Td key={`td-${index2}`}>{field(item)}</S.Td>
                    ))}
                  </S.Tr>
                );
              })}
          </S.Tbody>
        </S.Table>
      </S.TableCon>
      {pagination ? (
        <S.Pagination>
          <Pagination current={page} onChange={handleChnage} total={totlaItems} showSizeChanger={false} />
        </S.Pagination>
      ) : (
        <></>
      )}
    </>
  );
};

export default AppTable;
